import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { ProformaInvoiceApiModel } from '@era/inroom-sdk';
import { selectCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';
import { MobileFolioViewSaveOrder } from './mobilefolio-store/mobilefolio.actions';
import { selectCurrentMobileFolio } from './mobilefolio-store/mobilefolio.selector';
import { MobileFolioComponent } from './mobilefolio.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-mobile-folio',
  templateUrl: './mobilefolio.container.html',
  imports: [MobileFolioComponent],
})
export class MobileFolioContainerComponent {
  private readonly store = inject(Store);

  public readonly mobileFolio = this.store.selectSignal(selectCurrentMobileFolio);
  public readonly reservation = this.store.selectSignal(selectCurrentMobileReservation);

  public save(mobileFolio: ProformaInvoiceApiModel) {
    this.store.dispatch(new MobileFolioViewSaveOrder({ mobileFolio }));
  }
}
